/**
 * Profile Statistics Service
 * API service for fetching user profile statistics
 */

import { apiClient } from "@/lib/api-client"
import type { ProfileStatisticsResponse } from "../types/profile.types"

/**
 * Get user profile statistics
 * @param userId - The user ID to fetch statistics for
 * @param includeDrafts - Whether to include draft counts
 * @param includePaused - Whether to include paused coaching sessions (my-rituality owner view)
 * @returns Profile statistics response with teachings, practicing, and communities counts
 */
export const getProfileStatistics = async (
  userId: string,
  includeDrafts = false,
  includePaused = false,
): Promise<ProfileStatisticsResponse> => {
  const url = `/api/profiles/${userId}/statistics`
  const params = new URLSearchParams()
  if (includeDrafts) params.append("includeDrafts", "true")
  if (includePaused) params.append("includePaused", "true")
  const queryString = params.toString()
  const response = await apiClient.get(queryString ? `${url}?${queryString}` : url)
  return response.data
}
